import * as ACTION_TYPES from './actiontypes';

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.MANUAL_AUTOFINALIZE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Manually autofinalizing encounters'
      };
    }

    case ACTION_TYPES.MANUAL_AUTOFINALIZE_SUCCESS: {
      const { payload } = action;

      const nextAutofinalizeOptions =
        state.contractSettingsData.autofinalizeOptions.map(x => ({
          ...x,
          encounterCount: payload.submittedOptions.filter(y =>
            y.name === x.name && y.isChecked === true
          ).length > 0 ? 0 : x.encounterCount
        }));

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          autofinalizeOptions: nextAutofinalizeOptions
        }
      };
    }

    case ACTION_TYPES.MANUAL_AUTOFINALIZE_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.REMOVE_AUDIT_REASONS_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Removing audit reasons from encounters'
      };
    }

    case ACTION_TYPES.REMOVE_AUDIT_REASONS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.REMOVE_AUDIT_REASONS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.GET_AFFECTED_ENCOUNTERS_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Getting affected encounter count'
      };
    }

    case ACTION_TYPES.GET_AFFECTED_ENCOUNTERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.GET_AFFECTED_ENCOUNTERS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ENABLE_CLIENT_REVIEW_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Enabling client review'
      }
    }

    case ACTION_TYPES.ENABLE_CLIENT_REVIEW_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          isClientReviewEnabled: {
            ...state.contractSettingsData.isClientReviewEnabled,
            isChecked: true
          }
        }
      };
    }

    case ACTION_TYPES.ENABLE_CLIENT_REVIEW_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.DISABLE_CLIENT_REVIEW_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Disabling client review'
      }
    }

    case ACTION_TYPES.DISABLE_CLIENT_REVIEW_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          isClientReviewEnabled: {
            ...state.contractSettingsData.isClientReviewEnabled,
            isChecked: false
          }
        }
      };
    }

    case ACTION_TYPES.DISABLE_CLIENT_REVIEW_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ENABLE_AUTO_EXPORT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Enabling automatic exports'
      }
    }

    case ACTION_TYPES.ENABLE_AUTO_EXPORT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          autoExport: {
            ...state.contractSettingsData.autoExport,
            isChecked: true
          }
        }
      };
    }

    case ACTION_TYPES.ENABLE_AUTO_EXPORT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.DISABLE_AUTO_EXPORT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Disabling automatic exports'
      };
    }

    case ACTION_TYPES.DISABLE_AUTO_EXPORT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          autoExport: {
            ...state.contractSettingsData.autoExport,
            isChecked: false
          }
        }
      };
    }

    case ACTION_TYPES.DISABLE_AUTO_EXPORT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ENABLE_PURGE_DURING_NEXT_READ_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Enabling purge during next read'
      };
    }

    case ACTION_TYPES.ENABLE_PURGE_DURING_NEXT_READ_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          purgeContractDuringNextRead: {
            ...state.contractSettingsData.purgeContractDuringNextRead,
            isChecked: true
          }
        }
      };
    }

    case ACTION_TYPES.ENABLE_PURGE_DURING_NEXT_READ_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.DISABLE_PURGE_DURING_NEXT_READ_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Disabling purge during next read'
      };
    }

    case ACTION_TYPES.DISABLE_PURGE_DURING_NEXT_READ_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          purgeContractDuringNextRead: {
            ...state.contractSettingsData.purgeContractDuringNextRead,
            isChecked: false
          }
        }
      };
    }

    case ACTION_TYPES.DISABLE_PURGE_DURING_NEXT_READ_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ENABLE_DOC_PROC_AUTOFINALIZE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Enabling doc proc autofinalize'
      };
    }

    case ACTION_TYPES.ENABLE_DOC_PROC_AUTOFINALIZE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          documentProcessorAutofinalize: {
            ...state.contractSettingsData.documentProcessorAutofinalize,
            isChecked: true
          }
        }
      };
    }

    case ACTION_TYPES.ENABLE_DOC_PROC_AUTOFINALIZE_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.DISABLE_DOC_PROC_AUTOFINALIZE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Disabling doc proc autofinalize'
      };
    }

    case ACTION_TYPES.DISABLE_DOC_PROC_AUTOFINALIZE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          documentProcessorAutofinalize: {
            ...state.contractSettingsData.documentProcessorAutofinalize,
            isChecked: false
          }
        }
      };
    }

    case ACTION_TYPES.DISABLE_DOC_PROC_AUTOFINALIZE_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Enabling autofinalized encounter doc proc reads'
      };
    }

    case ACTION_TYPES.ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          documentProcessorReadAutofinalized: {
            ...state.contractSettingsData.documentProcessorReadAutofinalized,
            isChecked: true
          }
        }
      };
    }

    case ACTION_TYPES.ENABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_FAILURE: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Disabling autofinalized encounter doc proc reads'
      };
    }

    case ACTION_TYPES.DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          documentProcessorReadAutofinalized: {
            ...state.contractSettingsData.documentProcessorReadAutofinalized,
            isChecked: false
          }
        }
      };
    }

    case ACTION_TYPES.DISABLE_AUTOFINALIZED_ENCOUNTER_DOC_PROC_READ_FAILURE: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ENABLE_NEW_HCC_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Enabling new HCC audit'
      };
    }

    case ACTION_TYPES.ENABLE_NEW_HCC_AUDIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          newCodeCategoryAudit: {
            ...state.contractSettingsData.newCodeCategoryAudit,
            isChecked: true
          }
        }
      };
    }

    case ACTION_TYPES.ENABLE_NEW_HCC_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.DISABLE_NEW_HCC_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Disabling new HCC audit'
      };
    }

    case ACTION_TYPES.DISABLE_NEW_HCC_AUDIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          newCodeCategoryAudit: {
            ...state.contractSettingsData.newCodeCategoryAudit,
            isChecked: false
          }
        }
      };
    }

    case ACTION_TYPES.DISABLE_NEW_HCC_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ENABLE_UNVALIDATED_DX_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Enabling unvalidated DX audit'
      };
    }

    case ACTION_TYPES.ENABLE_UNVALIDATED_DX_AUDIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          unvalidatedDxes: {
            ...state.contractSettingsData.unvalidatedDxes,
            isChecked: true
          }
        }
      };
    }

    case ACTION_TYPES.ENABLE_UNVALIDATED_DX_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.DISABLE_UNVALIDATED_DX_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Disabling unvalidated DX audit'
      };
    }

    case ACTION_TYPES.DISABLE_UNVALIDATED_DX_AUDIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          unvalidatedDxes: {
            ...state.contractSettingsData.unvalidatedDxes,
            isChecked: false
          }
        }
      };
    }

    case ACTION_TYPES.DISABLE_UNVALIDATED_DX_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ENABLE_CODER_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Enabling coder audit'
      };
    }

    case ACTION_TYPES.ENABLE_CODER_AUDIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          coderAudit: {
            ...state.contractSettingsData.coderAudit,
            isChecked: true
          }
        }
      };
    }

    case ACTION_TYPES.ENABLE_CODER_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.DISABLE_CODER_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Disabling coder audit'
      };
    }

    case ACTION_TYPES.DISABLE_CODER_AUDIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          coderAudit: {
            ...state.contractSettingsData.coderAudit,
            isChecked: false
          }
        }
      };
    }

    case ACTION_TYPES.DISABLE_CODER_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ENABLE_CC_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Enabling code category audit'
      };
    }

    case ACTION_TYPES.ENABLE_CC_AUDIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          codeCategoryAudit: {
            ...state.contractSettingsData.codeCategoryAudit,
            isChecked: true
          }
        }
      };
    }

    case ACTION_TYPES.ENABLE_CC_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.DISABLE_CC_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Disabling code category audit'
      };
    }

    case ACTION_TYPES.DISABLE_CC_AUDIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          codeCategoryAudit: {
            ...state.contractSettingsData.codeCategoryAudit,
            isChecked: false
          }
        }
      };
    }

    case ACTION_TYPES.DISABLE_CC_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ENABLE_DX_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Enabling DX audit'
      };
    }

    case ACTION_TYPES.ENABLE_DX_AUDIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          dxCodeAudit: {
            ...state.contractSettingsData.dxCodeAudit,
            isChecked: true
          }
        }
      };
    }

    case ACTION_TYPES.ENABLE_DX_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.DISABLE_DX_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Disabling DX audit'
      };
    }

    case ACTION_TYPES.DISABLE_DX_AUDIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          dxCodeAudit: {
            ...state.contractSettingsData.dxCodeAudit,
            isChecked: false
          }
        }
      };
    }

    case ACTION_TYPES.DISABLE_DX_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.PLACE_DX_ON_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Placing DX on audit'
      };
    }

    case ACTION_TYPES.PLACE_DX_ON_AUDIT_SUCCESS: {
      const { payload } = action;

      const nextAuditedDxes = [
        ...state.contractSettingsData.dxCodeAudit.auditedDxes,
        payload.encoding
      ];

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          dxCodeAudit: {
            ...state.contractSettingsData.dxCodeAudit,
            auditedDxes: nextAuditedDxes
          }
        }
      };
    }

    case ACTION_TYPES.PLACE_DX_ON_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.REMOVE_DX_FROM_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Removing DX from audit'
      };
    }

    case ACTION_TYPES.REMOVE_DX_FROM_AUDIT_SUCCESS: {
      const { payload } = action;

      const isNotRemovedDx = x => x.cmsCodeId !== payload.encoding.cmsCodeId;
      const nextAuditedDxes =
        state.contractSettingsData.dxCodeAudit.auditedDxes.filter(isNotRemovedDx);

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          dxCodeAudit: {
            ...state.contractSettingsData.dxCodeAudit,
            auditedDxes: nextAuditedDxes
          }
        }
      };
    }

    case ACTION_TYPES.REMOVE_DX_FROM_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.PLACE_CODER_ON_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Placing coder on audit'
      };
    }

    case ACTION_TYPES.PLACE_CODER_ON_AUDIT_SUCCESS: {
      const { payload } = action;

      const nextAuditedCoders = [
        ...state.contractSettingsData.coderAudit.auditedCoders,
        payload.coder
      ];

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          coderAudit: {
            ...state.contractSettingsData.coderAudit,
            auditedCoders: nextAuditedCoders
          }
        }
      };
    }

    case ACTION_TYPES.PLACE_CODER_ON_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.REMOVE_CODER_FROM_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Removing coder from audit'
      };
    }

    case ACTION_TYPES.REMOVE_CODER_FROM_AUDIT_SUCCESS: {
      const { payload } = action;

      const isNotAuditedCoder = x => x.coderId !== payload.coder.coderId;
      const nextAuditedCoders = state.contractSettingsData.coderAudit
        .auditedCoders.filter(isNotAuditedCoder);

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          coderAudit: {
            ...state.contractSettingsData.coderAudit,
            auditedCoders: nextAuditedCoders
          }
        }
      };
    }

    case ACTION_TYPES.REMOVE_CODER_FROM_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.PLACE_CC_ON_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Placing CC on audit'
      };
    }

    case ACTION_TYPES.PLACE_CC_ON_AUDIT_SUCCESS: {
      const { payload } = action;

      const nextAuditedCCs = [
        ...state.contractSettingsData.codeCategoryAudit.auditedCodeCategories,
        payload.codeCategory
      ];

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          codeCategoryAudit: {
            ...state.contractSettingsData.codeCategoryAudit,
            auditedCodeCategories: nextAuditedCCs
          }
        }
      };
    }

    case ACTION_TYPES.PLACE_CC_ON_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.REMOVE_CC_FROM_AUDIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Removing CC from audit'
      };
    }

    case ACTION_TYPES.REMOVE_CC_FROM_AUDIT_SUCCESS: {
      const { payload } = action;

      const isNotRemovedCC = x =>
        x.codeCategoryId !== payload.codeCategory.codeCategoryId;

      const nextAuditedCCs = state.contractSettingsData.codeCategoryAudit
        .auditedCodeCategories.filter(isNotRemovedCC);

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          codeCategoryAudit: {
            ...state.contractSettingsData.codeCategoryAudit,
            auditedCodeCategories: nextAuditedCCs
          }
        }
      };
    }

    case ACTION_TYPES.REMOVE_CC_FROM_AUDIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.HYDRATE: {
      const { payload: { contractSettingsData } } = action;

      return {
        ...state,
        contractSettingsData
      };
    }

    case ACTION_TYPES.PURGE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Setting encounters to be purged...'
      };
    }

    case ACTION_TYPES.PURGE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.PURGE_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.PRIORITY_WORKBY_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Updating Next Record Work By Setting'
      };
    }

    case ACTION_TYPES.PRIORITY_WORKBY_SUCCESS: {
      const { payload } = action;

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          priorityWorkBy: payload.item
        }
      };
    }

    case ACTION_TYPES.PRIORITY_WORKBY_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.PRIORITY_STRATEGY_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Updating Next Record Sort Setting'
      };
    }

    case ACTION_TYPES.PRIORITY_STRATEGY_SUCCESS: {
      const { payload } = action;

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          priorityStrategy: payload.item
        }
      };
    }

    case ACTION_TYPES.PRIORITY_STRATEGY_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ENABLE_ENCOUNTER_AUTO_REREAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Updating Contract Auto Reread Setting'
      };
    }

    case ACTION_TYPES.ENABLE_ENCOUNTER_AUTO_REREAD_SUCCESS: {

      const curContract = Object.assign({}, state.contractSettingsData.selectedContract);
      curContract.isRereadDisabled = false;

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          selectedContract: curContract
        }
      };
    }

    case ACTION_TYPES.ENABLE_ENCOUNTER_AUTO_REREAD_ERROR: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.DISABLE_ENCOUNTER_AUTO_REREAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Updating Contract Auto Reread Setting'
      };
    }

    case ACTION_TYPES.DISABLE_ENCOUNTER_AUTO_REREAD_SUCCESS: {
      const curContract = Object.assign({}, state.contractSettingsData.selectedContract);
      curContract.isRereadDisabled = true;

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        contractSettingsData: {
          ...state.contractSettingsData,
          selectedContract : curContract
        }
      };
    }

    case ACTION_TYPES.DISABLE_ENCOUNTER_AUTO_REREAD_ERROR: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    default: {
      throw new Error('contractManagement reducer default case should never hit');
    }
  }
};

export default reducer;
